import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const fetchPartners = (setPartners: Function, setPartnersLoading: Function, language: string) => {
  setPartnersLoading(true);

  ApiService.get("partners?order_by=name&order=asc")
    .then((response) => setPartners(response.data.partners))
    .catch((error) => {
      console.error("Error fetching partners:", error);
      alert(translate(language, "PAGES.EVALUATION.PARTNERS_MODAL.ERRORS.PARTNERS"));
    })
    .finally(() => setPartnersLoading(false));
};

export const updateEvaluationPartners = (
  evaluationId: string,
  partnerIds: number[],
  setLoading: Function,
  onSuccess: Function,
  language: string
) => {
  setLoading(true);

  ApiService.put(`evaluations/${evaluationId}/partners`, { partner_ids: partnerIds })
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Error updating evaluation partners:", error);
      alert(translate(language, "PAGES.EVALUATION.PARTNERS_MODAL.ERRORS.UPDATE"));
    })
    .finally(() => setLoading(false));
};
